import React from 'react';
import PropTypes from 'prop-types';
import { getParentSibling, getNextSibling } from '../scripts/accessibility';
var handleKeyDown = function handleKeyDown(event) {
  var keyCode = event.keyCode;
  var leftArrow = 37;
  var rightArrow = 39;
  var currentDomEl = event.target;
  if (keyCode === leftArrow || keyCode === rightArrow) {
    var direction = keyCode === leftArrow ? 'previous' : 'next';
    var nextElement = getNextSibling(currentDomEl, direction) || getParentSibling(currentDomEl, direction);
    if (nextElement) {
      nextElement.focus();
    }
  }
};
var Logo = function Logo(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$imgSrc = _ref.imgSrc,
    imgSrc = _ref$imgSrc === void 0 ? '' : _ref$imgSrc,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow;
  if (imgSrc) {
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      role: url ? undefined : 'presentation',
      onKeyDown: handleKeyDown
    }, url ? /*#__PURE__*/React.createElement("a", {
      className: "logo__link",
      href: url,
      target: newWindow ? '_blank' : '_parent',
      rel: newWindow ? 'noopener noreferrer' : null
    }, /*#__PURE__*/React.createElement("img", {
      src: imgSrc,
      alt: alt
    })) : /*#__PURE__*/React.createElement("img", {
      src: imgSrc,
      alt: alt
    }));
  }
  return null;
};
export default Logo;
Logo.propTypes = {
  imgSrc: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string,
  newWindow: PropTypes.bool
};